<template>
  <div>
    <div class="file-item flex-column flex-md-row"
         v-for="input in getMissingInputs()" v-if="currentJob.apiJob?.warnings.length > 0">
      <div class="item d-inline-flex gap-10px">
        <input type="checkbox" disabled>
        <div class="item hoverFileListItem">
          <div class="thumb-small no-preview"
          >
            <i class="far fa-file"></i>
          </div>
        </div>
        <span
            class="short-text-name"
        >{{ input.filename }}</span>
        <span class="text-muted">
            {{ getReadableSize(input.size) }}
          </span>
      </div>

      <div class="flex-grow-1 justify-content-end d-flex file-actions item align-items-center">
        <div>
          <div class="file-warning m-0">
            <strong>{{ translate('Could not convert this file') }}
            </strong>
          </div>
        </div>
      </div>

      </div>
    </div>
</template>
<script>
import store from './../../../mixins/store.mixin'
import currentJob from './../../../mixins/current_job.mixin'
import PreviewManager from "../../../manager/PreviewManager";
import JobManager from "../../../manager/JobManager";
import OutputSelectionManager from "../../../manager/OutputSelectionManager";
import DownloadManager from "../../../manager/DownloadManager";
import ThumbnailManager from "../../../manager/ThumbnailManager";
import Error from "../../Elements/Error.vue";
import {formatting} from "../../../../../../../helper/formatting";
import Analytics from "../../../util/Analytics";
import FeedbackFull from "../../Elements/FeedbackFull.vue";

export default {
  name: "FileListOutputsWarning",
  props: {},
  components: {FeedbackFull, Error},
  mixins: [
    store,
    currentJob
  ],
  data() {
    return {
      hoverOutput: {id: null}
    };
  },
  mounted: function () {

  },
  created: function () {
  },
  filters: {
  },
  methods: {
    getReadableSize(size) {
      return formatting.fileSize(size);
    },
    getMissingInputs() {
      if (this.complete !== true) {
        return [];
      }
      return JobManager.getMissingInputs(this.currentJob);
    },
  },
  computed: {}
};
</script>
<style lang="scss" scoped>
.short-text-name {
  max-width: 300px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.gap-10px {
  gap: 10px;
}

.filename-cursor {
  pointer-events: inherit;
  cursor: pointer;
}

.bg-selected {
  background: #f8f8ff !important;
  border-bottom: 1px solid #D9E7FD !important;
}

.thumb-small {
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 50px;
  height: 50px;
  z-index: 10;
  overflow: hidden;

  &.no-preview {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #F5F5F5;
    color: #6C757D;
    cursor: inherit;
  }

  img {
    object-fit: cover;
    width: 50px;
    height: 50px;
  }

  .placeholder {
    height: 135px !important;
    border-radius: 9px;
    overflow: hidden;
  }

  .animated-background {
    height: 135px !important;
    border-radius: 9px;
    overflow: hidden;
  }
}

.thumb-preview {
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 150px;
  height: auto;
  position: absolute;
  right: -170px;
  top: -55px;
  padding: 5px;
  z-index: 10;

  img {
    z-index: 100;
    border-radius: 0px;
  }

  .placeholder {
    height: 135px !important;
    border-radius: 9px;
    overflow: hidden;
  }

  .animated-background {
    height: 135px !important;
    border-radius: 9px;
    overflow: hidden;
  }

  &:before {
    z-index: -1;
    content: "";
    position: absolute;
    top: 45px;
    left: -10px;
    height: 20px;
    width: 20px;
    background: white;
    transform: rotate(45deg);
    border-left: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
  }
}

.placeholder {
  margin: 0;
  width: 100%;
  max-width: 1400px;
  background-color: #eee;
  border-radius: 4px !important;
  overflow: hidden;
}

@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0
  }
  100% {
    background-position: 1468px 0
  }
}

.animated-background {
  animation-duration: 1.25s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: darkgray;
  background: linear-gradient(to right, #eeeeee 10%, #dddddd 18%, #eeeeee 33%);
  background-size: 2800px 104px;
  height: 100%;
  position: relative;
  top: 0;
}


#preview-img {
  transition: width 2s, height 4s;
  background: white;
  border: 1px solid #ccc;
  display: none;
  width: 100px;
  height: auto;
  z-index: 1000;
  padding: 5px;
  position: absolute;
  max-height: 300px;
  overflow: hidden;
}

.line-through {
  text-decoration: line-through;
}

.spinner-basic {
  border: 2px solid #2e2e2e;
  border-right-color: transparent;

  .dark-mode & {
    border: 2px solid white;
    border-right-color: transparent;
  }
}

.global-actions-container-top {
  border-bottom: 1px solid #CBCBCB;

  .dark-mode & {
    border-bottom: 1px solid #595959;
  }
}

.global-actions-container {
  padding: 10px;

  .dark-mode & {
    background: #272727;
    color: white;
  }
}

.feedback-full {
  background: white;
  border: 1px solid #CBCBCB;
  border-radius: 4px;
  padding: 20px;
}

.file-container {
  border: 1px solid #CBCBCB;
  border-radius: 4px;
  width: 100%;
  background: #FBFBFB;

  .dark-mode & {
    border: 1px solid #595959;
  }
}

.file-actions {
  gap: 10px;
}

.file-item {
  .item {
    display: flex;
    align-items: center;
  }

  vertical-align: center;
  padding: 10px;
  display: flex;
  gap: 5px;
  background: white;
  border-bottom: 1px solid #CBCBCB;

  .dark-mode & {
    background: #272727;
    border-bottom: 1px solid #595959;
    color: white;
  }
}

.download-btn {
  cursor: pointer;
  background: #1266F1;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 4px;
}

.upload-btn {
  cursor: pointer;

  i {
    line-height: inherit;
  }

  background: #F2F2F2;
  border: 1px solid #CBCBCB;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 4px;
}

.file-action-btn {
  background: #F2F2F2;
  border: 1px solid #CBCBCB;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 4px;
  cursor: pointer;

  .dark-mode & {
    background: #383838;;
    border: 1px solid #595959;
    color: white;

    &:hover {
      background: #323232;
    }
  }
}

.file-warning {
  background: #FFF1D6;
  color: #8F6C25;
  border: 1px solid #8F6C25;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 4px;
}

.compress-failed {
  background: #F2F2F2;
  border: 1px solid #CBCBCB;
  color: #6C757D;
  font-size: 12px;
  font-weight: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 4px;
}

.placeholder {
  margin: 0 auto;
  max-width: 400px;
  min-height: 25px;
  height: 25px;
  overflow: hidden;
  border-radius: 4px;
  opacity: .6;
  background-color: #eee;
  transition: all 1s;
}

@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0
  }
  100% {
    background-position: 468px 0
  }
}

.animated-background {
  animation-duration: 1.25s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: darkgray;
  background: linear-gradient(to right, #eeeeee 10%, #dddddd 18%, #eeeeee 33%);
  background-size: 800px 104px;
  height: 100px;
  position: relative;
}
</style>
